import {useEffect} from 'react'
import {useSelector} from 'react-redux'
import {toggle} from 'opticks/lib/optimizely'

import {useAuth} from '../components/AuthProvider'
import {selectIsAuthenticated, selectIsLoading} from '../modules/selectors'
import {UseCognitoType} from '../modules/useCognito'
import {AuthContextType} from '../types/Auth'

const useToggleAuth = () => {
  const auth0Values = useAuth()
  const isAuthenticated = useSelector(selectIsAuthenticated)
  const isLoading = useSelector(selectIsLoading)

  return toggle('f54ef0b3-cognito-auth', auth0Values, {
    isAuthenticated,
    isLoading
  }) as
    | Partial<AuthContextType>
    | Pick<UseCognitoType, 'isAuthenticated' | 'isLoading'>
}

export const useExecutionIfNotAuthenticated = (callback: () => void) => {
  const {isAuthenticated, isLoading} = useToggleAuth()

  useEffect(() => {
    if (!isAuthenticated && !isLoading) callback()
  }, [isAuthenticated, isLoading])
}
